export const bankDeposit = {
  depositInstructions: "Deposit Instructions",
  depositInstructionsMessageVzla:
    "Register your mobile payment for automatic BDV payments. If you've already paid without registering, use this form.",
  depositInstructionsMessagePlaza:
    "Dear user, to validate your mobile payment and credit it to your virtual wallet, it must be made with the same ID and phone number you used to register your account. If you have another phone number associated with the same ID, simply add it to your mobile payment accounts for the payment to be credited.",
  depositInstructionsImportantMessage: "IMPORTANT: The balance will be updated when you click continue",
  depositInstructionsBank: "Bank",
  depositInstructionsMobilePhone: "Phone",
  depositInstructionsContinue: "Continue",
  depositInstructionsBack: "Back",
  depositInstructionsCancel: "Cancel",
  depositInstructionsCopy: "Copy",
  depositInstructionsCopied: "Copied",
  depositInstructionsError: "There was an error:",
  depositInstructionsOptions: "To continue, please choose from the available deposit methods below",
  depositInstructionsBankTitle: "Success!",
  depositInstructionsBankSuccess: "Deposit consolidated with success!",
  depositInstructionsBankWarning: "Attention!",
  depositInstructionsBanckError: "No transaction was found",

  depositInstructionsBankOptionsTitle: "To continue, please choose one of your preferred banks.",
  depositInstructionsBankOptions: "Select a bank",
  depositInstructionsBankVzlaSelectDate: "Select Date",

  depositInstructionsCancelBtn: "Cancel",
  depositInstructionsCopyBtnTitle: "Press the button to copy",

  // VENEZUELA BANK
  depositInstructionsBankVzlaReference: "Reference",
  depositInstructionsBankVzlaAmount: "Amount",
  depositInstructionsBankVzlaDate: "Date",
  depositInstructionsBankVzlaBank: "Bank",
  depositInstructionsBankVzlaBankOptions: "Select a bank",
  depositInstructionsBankVzlaForm: "Form",
  depositInstructionsBankVzlaFormTitle: "Payment Registration Form",
  depositInstructionsBankVzlaFormInfo: "Use the form if you have already paid.",

  //ZELLE
  depositInstructionsZelleMessage:
    "Before making this Zelle transaction, you must contact support to verify the conversion of USD to Bolívares and validate your payment",
  depositInstructionsZelleEmail: "E-mail",
  depositInstructionsZelleCopyBtnTitle: "Tap the button to copy the email",
  depositInstructionsSupport: "Contact Support",

  //BINANCE
  depositInstructionsBinanceTitle: "Binance USDT Deposit",
  depositInstructionsBinanceAmount: "Amount",
  depositInstructionsBinanceMinAmount: "Minimum deposit",
  depositInstructionsBinanceCompletePayment: "Complete Your Binance Payment",
  depositInstructionsBinanceOptions: "Choose your preferred payment method below",
  depositInstructionsBinanceOptionsTitle: "Payment Methods",
  depositInstructionsBinanceUseQR: "Scan this QR code with your Binance app",
  depositInstructionsBinanceLink: "Click to open the payment page in Binance",
  depositInstructionsBinanceOpenLink: "Open Binance Payment Link",
  depositInstructionsBinanceStatus: "Transaction Status",
  depositInstructionsBinanceContinue: "Continue",
  depositInstructionsBinanceBack: "Back",
  depositInstructionsBinanceCheckingStatus: "Checking status...",
  depositInstructionsBinancePending: "pending",
  depositInstructionsBinanceEnterAmount: "Enter amount to deposit",
  depositInstructionsBinanceGeneratedLink: "Payment link generated! Choose your preferred payment method.",
  depositInstructionsBinanceError: "Failed to create deposit. Please try again.",
  depositInstructionsBinanceValidAmount: "Please enter a valid amount",
  depositInstructionsBinancePaymentCompleted: "Payment completed successfully!",

  //PAYKU
  depositInstructionsPaykuTitle: "Payku CLP Deposit",
  depositInstructionsPaykuDescription: "Make deposits in Chilean Pesos using various payment methods",
  depositInstructionsPaykuAmount: "Amount",
  depositInstructionsPaykuEmail: "Email",
  depositInstructionsPaykuPaymentMethod: "Payment Method",
  depositInstructionsPaykuMinAmount: "Minimum deposit: 1,000 CLP",
  depositInstructionsPaykuEnterAmount: "Enter amount to deposit",
  depositInstructionsPaykuEmailPlaceholder: "your@email.com",
  depositInstructionsPaykuSelectMethod: "Select payment method",
  depositInstructionsPaykuCreatePayment: "Create Payment",
  depositInstructionsPaykuCompletePayment: "Complete Your Payku Payment",
  depositInstructionsPaykuOptions: "Complete your payment in the opened window.",
  depositInstructionsPaykuOpenLink: "Open Payment Link",
  depositInstructionsPaykuStatus: "Payment Status",
  depositInstructionsPaykuCheckingStatus: "Checking status...",
  depositInstructionsPaykuPending: "Pending",
  depositInstructionsPaykuapproved: "Approved",
  depositInstructionsPaykucompleted: "Completed",
  depositInstructionsPaykurejected: "Rejected",
  depositInstructionsPaykuexpired: "Expired",
  depositInstructionsPaykuInstructions: "You will be redirected back once payment is processed.",
  depositInstructionsPaykuError: "Failed to create payment. Please try again.",
  depositInstructionsPaykuValidEmail: "Please enter a valid email address",
  depositInstructionsPaykuPaymentCompleted: "Payment completed successfully!",
  depositInstructionsPaykuPaymentRejected: "Payment was rejected",
  depositInstructionsPaykuPaymentExpired: "Payment expired",
  depositInstructionsPaykuUnsupportedCurrency: "Currency not supported",
  depositInstructionsPaykuOnlyCLP: "Payku is only available for Chilean Pesos (CLP)",
  depositInstructionsPaykuAllMethods: "All Methods",
  depositInstructionsPaykuAllMethodsDescription: "Recommended - All available methods",
  depositInstructionsPaykuWebpayDescription: "Most common payment method",
  depositInstructionsPaykuWebpayPlus1_3: "Webpay plus (1-3 installments)",
  depositInstructionsPaykuWebpayPlus4_6: "Webpay plus (4-6 installments)",
  depositInstructionsPaykuWebpayPlus7_12: "Webpay plus (7-12 installments)",
  depositInstructionsPaykuWebpayPlusDesc: "Credit option",

  // PAYKU WITHDRAWAL
  withdrawalPaykuTitle: "Payku CLP Withdrawal",
  withdrawalPaykuAvailableBalance: "Available Balance",
  withdrawalPaykuAmount: "Amount",
  withdrawalPaykuBeneficiaryName: "Beneficiary Name",
  withdrawalPaykuEmail: "Email",
  withdrawalPaykuPhone: "Phone",
  withdrawalPaykuRUT: "Chilean RUT",
  withdrawalPaykuBank: "Bank",
  withdrawalPaykuAccountType: "Account Type",
  withdrawalPaykuAccountNumber: "Account Number",
  withdrawalPaykuMinAmount: "Minimum withdrawal: 1,000 CLP",
  withdrawalPaykuEnterAmount: "Enter amount to withdraw",
  withdrawalPaykuBeneficiaryNamePlaceholder: "Full name of account holder",
  withdrawalPaykuEmailPlaceholder: "your@email.com",
  withdrawalPaykuPhonePlaceholder: "+56912345678",
  withdrawalPaykuRUTPlaceholder: "12345678-9",
  withdrawalPaykuRUTFormat: "Format: 12345678-9",
  withdrawalPaykuSelectBank: "Select bank",
  withdrawalPaykuAccountNumberPlaceholder: "Account number",
  withdrawalPaykuSubmit: "Submit Withdrawal",
  withdrawalPaykuSuccess: "Withdrawal request submitted successfully!",
  withdrawalPaykuError: "Failed to submit withdrawal. Please try again.",
  withdrawalPaykuInsufficientBalance: "Insufficient balance",
  withdrawalPaykuBeneficiaryNameRequired: "Beneficiary name is required",
  withdrawalPaykuValidEmail: "Please enter a valid email address",
  withdrawalPaykuPhoneRequired: "Phone number is required",
  withdrawalPaykuValidRUT: "Please enter a valid Chilean RUT (format: 12345678-9)",
  withdrawalPaykuBankRequired: "Please select a bank",
  withdrawalPaykuAccountNumberRequired: "Account number is required",
  withdrawalPaykuUnsupportedCurrency: "Currency not supported",
  withdrawalPaykuOnlyCLP: "Payku withdrawals are only available for Chilean Pesos (CLP)",

  // PAYKU CALLBACK PAGE
  paykuCallbackVerifying: "Verifying Payment",
  paykuCallbackVerifyingMessage: "Please wait while we verify your transaction status...",
  paykuCallbackSuccess: "Payment Successful!",
  paykuCallbackSuccessMessage:
    "Your deposit has been processed successfully. The balance has been credited to your account.",
  paykuCallbackFailed: "Payment Failed",
  paykuCallbackFailedMessage: "Sorry, your payment could not be processed. Please try again or contact support.",
  paykuCallbackPending: "Payment Pending",
  paykuCallbackPendingMessage: "Your payment is being processed. You will receive a notification when it's complete.",
  paykuCallbackOrderId: "Order ID",
  paykuCallbackAmount: "Amount",
  paykuCallbackRedirectMessage: "You will be redirected to the home page in {{seconds}} seconds...",
  paykuCallbackGoHome: "Go to Home",
};
